import { SxProps, Theme } from '@mui/material';
import { SHADOWS } from '../../../styles/sxStyling';

export const loadingContainerStyles: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const dialogHeaderStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 2,
  pt: 2,
};

// TILE
export const availabilityTileInteractiveStyles = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  transition: 'all 0.15s ease',
  '&:hover': {
    ...SHADOWS.secondary,
    borderColor: 'divider',
  },
};

export const tileDayNameStyles: SxProps<Theme> = {
  fontSize: '0.75rem',
  textTransform: 'uppercase',
  color: 'text.secondary',
  fontWeight: 600,
};

export const availabilityTileDateContainerStyles: SxProps<Theme> = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const availabilityTileStatusTextContainerStyles: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const availabilityTileStatusTextStyles: SxProps<Theme> = {
  fontWeight: 500,
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

export const availabilityTileDotContainerStyles: SxProps<Theme> = {
  width: 24,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const availabilityTileDotStyles: SxProps<Theme> = {
  width: 8,
  height: 8,
  borderRadius: '50%',
};

// Modals
export const contentContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  mt: 1,
};

export const weekdaysTitleStyles: SxProps<Theme> = {
  fontWeight: 600,
  mb: 1,
};

export const weekdaysContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  justifyContent: 'space-around',
  width: '100%',
};

export const weekdayBoxStyles = (selected: boolean): SxProps<Theme> => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  cursor: 'pointer',
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  border: '1px solid',
  borderColor: selected ? 'primary.main' : 'divider',
  bgcolor: selected ? 'primary.main' : 'background.paper',
  color: selected ? 'primary.contrastText' : 'text.primary',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: 'primary.main',
  },
});

export const infoBoxStyles: SxProps<Theme> = {
  borderRadius: 2,
  backgroundColor: 'rgba(255, 152, 0, 0.06)',
  p: 1.5,
};

export const infoTextStyles: SxProps<Theme> = {
  fontSize: '0.85rem',
  color: 'text.secondary',
  fontWeight: 600,
};

export const baseErrorStyles: SxProps<Theme> = {
  p: 1.5,
  borderRadius: 1,
  backgroundColor: 'error.light',
  color: 'error.contrastText',
};

export const dialogActionsStyles: SxProps<Theme> = {
  px: 3,
  pb: 2,
};
